import {helpers} from 'commerce-sdk-isomorphic';

import {IBaseFetchOptions, ICustomApiConfig, ICustomApiEndpoint} from './ICustomApiConfig';

/**
 * Represents AbstractCustomShopperAPI
 */
abstract class AbstractCustomShopperAPI {
	protected readonly config: ICustomApiConfig;

	/**
	 * @constructor
	 * @param {ICustomApiConfig} config - API Config
	 */
	protected constructor(config: ICustomApiConfig) {
		this.config = config;
	}

	/**
	 * Calls custom api endpoint
	 * @param {IBaseFetchOptions} fetchOptions
	 * @param {ICustomApiEndpoint} endpoint
	 */
	protected async callCustomEndpoint<T>(fetchOptions: IBaseFetchOptions, endpoint: ICustomApiEndpoint): Promise<T> {
		const endpointModified = {...endpoint, path: this.applyPathParameters(fetchOptions, endpoint)};

		return await helpers.callCustomEndpoint({
			options: {
				...fetchOptions,
				method: endpointModified.method,
				customApiPathParameters: {
					...this.config.customApiConfig,
					endpointPath: endpointModified.path
				},
			},
			clientConfig: this.config,
		}) as T;
	}

	/**
	 * Applies pathParameters in the fetch options to the final path
	 * @param {IBaseFetchOptions} fetchOptions
	 * @param {ICustomApiEndpoint} endpoint
	 * @returns {string} - The modified path with applied path parameters
	 */
	private applyPathParameters(fetchOptions: IBaseFetchOptions, endpoint: ICustomApiEndpoint): string {
		let modifiedPath = endpoint.path;

		if (fetchOptions.pathParameters) {
			for (const pathParameter in fetchOptions.pathParameters) {
				modifiedPath = modifiedPath.replace(`{${pathParameter}}`, fetchOptions.pathParameters[pathParameter]);
			}
		}

		return modifiedPath;
	}
}

export default AbstractCustomShopperAPI;
